import NextApp from "next/app";
import { SiteContext, useSiteContext } from "hooks/use-site";
import { SearchProvider } from "hooks/use-search";
import NProgress from "components/NProgress";

import "styles/globals.scss";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";
import Script from "next/script";
import { defaultMetaSiteData } from "data/site";
import Head from "next/head";

function App({ Component, pageProps, metadata, locale }) {
  const site = useSiteContext({ metadata, locale });
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
      </Head>
      <SiteContext.Provider value={site}>
        <SearchProvider>
          <NProgress />
          <Script
            strategy="lazyOnload"
            src={`https://www.googletagmanager.com/gtag/js?id=${process.env.GOOGLE_ANALYTICS_ID}`}
          />
          <Script strategy="lazyOnload">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', '${process.env.GOOGLE_ANALYTICS_ID}');
            `}
          </Script>
          <Component {...pageProps} />
        </SearchProvider>
      </SiteContext.Provider>
    </>
  );
}

App.getInitialProps = async function (appContext) {
  const appProps = await NextApp.getInitialProps(appContext);
  const {
    ctx: { locale },
  } = appContext;
  const metadata = defaultMetaSiteData;
  return {
    ...appProps,
    metadata,
    locale: locale?.toUpperCase() || "en",
  };
};

export default App;
